module.exports = __webpack_public_path__ + "img/SITE WEB - Page Offres d'AlternancePic.a131c09.png";